import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=0ffb7427&scoped=true"
import script from "@/views/Errors/PageNotFound.ts?vue&type=script&lang=ts&external"
export * from "@/views/Errors/PageNotFound.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Errors/page_not_found.scss?vue&type=style&index=0&id=0ffb7427&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb7427",
  null
  
)

export default component.exports